import { PrivateLinks } from '@/components/shared/PrivateLinks';
import { AppRoutes } from '@/i18n/constants';

export const LinkToMissionPageWrapper = ({ enabled, children }: { enabled?: boolean; children: React.ReactNode }) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <PrivateLinks href={AppRoutes.gamificationMissions} className="contents">
      {children}
    </PrivateLinks>
  );
};
